<template>
  <div class="container justify-content-center mt-5">
    <div class="row d-flex justify-content-center company-product-payment-success-page">
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.purchase_could_not_completed_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.purchase_could_not_completed_text) }}
        </p>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Webshop Payment Failed Page
 */
import "../../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../../components/atoms/Button.vue";
import common from "../../../../functions/index";
import Constants from "../../../../constants/index";

export default {
  name: "webshop-payment-success",
  async created() {
    try {
      const trType = this.$route.params.type;
      // const id = this.$route.params.id;
      // console.log(id);

      switch (trType) {
        case "card":
          {
            let sessData = await this.$store.dispatch("getStripeCheckoutSession", { id: this.$route.params.id, connectedAccount: this.$route.params.connectedAccount });

            this.paymentIntent = await this.$store.dispatch("getStripePaymentIntent", { id: sessData["payment_intent"], StripeAccount: this.$route.params.connectedAccount });

            let formData = common.getFromLocalStorage(this.$route.params.id);

            let updatePayload = {
              id: formData.webshop_payment_id,
              webshop_payment: {
                order_reference_id: this.paymentIntent.data.id,
                return_log: JSON.stringify(this.paymentIntent),
                date_paid: this.paymentIntent.data.charges.data[0].created,
                status: "failed",
                method: trType,
              },
            };

            await this.updateWebShopPayment(updatePayload);
          }

          break;
      }
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.retrieving_session_error_heading),
        text: this.$t(this.LangConstants.stripe_api_error_text),
        type: "error",
        html: "",
      });
    }
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    MyButton,
  },
};
</script>
